<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm">
          <el-col>
            <el-form-item label="名称：">
              <el-input size="medium" placeholder="请输入套餐名称" minlength="2" maxlength="10" v-model="searchForm.NAME" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select size="medium" v-model="searchForm.STATUS" @change="handleCurrentChange(1)">
                <el-option value="0" label="禁用"></el-option>
                <el-option value="1" label="在用"></el-option>
              </el-select>
            </el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)">筛选</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd">添加在用套餐</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border style="margin-top: 20px" :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编号"></el-table-column>
          <el-table-column prop="NAME" label="套餐名称"></el-table-column>
          <el-table-column prop="STATUS" label="状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.STATUS == 1">在用</el-tag>
              <el-tag type="danger" v-else>禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="matchDishes(scope.row)" type="text">配置菜品</el-button>
              <el-button @click="deleteRecord(scope.row)" type="text" style="color: red" v-if="scope.row.STATUS == 1">禁用
              </el-button>
              <el-button @click="deleteRecord(scope.row)" type="text" v-else>启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增/修改模态框 -->
    <el-dialog title="添加在用套餐" center :visible.sync="editFormVisible" width="360px">
      <el-form :model="editForm" ref="editForm" size="small" :inline="true">
        <el-form-item label="套餐名称：">
          <el-autocomplete v-model="editForm.NAME" :fetch-suggestions="querySearchAsync" placeholder="请输入内容"
            @select="handleSelect" clearable></el-autocomplete>
        </el-form-item>
        <el-button type="text" @click="submitAdd()">未查找到想要结果，立即添加</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" @click="matchProduct()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryPackageName, addPackageFun, changePackageFun, matchPackageFun, searchAllPackageFun,
} from 'api/packageManage';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      searchForm: {
        STATUS: '1',
      },
      editFlag: 0,
      editFormVisible: false,
      editForm: {},
      packageLists: [],
      timeout: null,
    };
  },
  created() {
    this.queryData();
    sessionStorage.removeItem('productArr');
  },
  computed: {
    SAVE_PRODOCTION_LIST() {
      return this.$store.state.PRODUCTION_LIST;
    },
  },
  methods: {
    querySearchAsync(queryString, cb) {
      if (queryString) {
        const params = {
          NAME: queryString,
        };
        searchAllPackageFun(params)
          .then((result) => {
            result = JSON.parse(JSON.stringify(result).replace(/NAME/g, 'value')); // 将返回数据中AB_NAME字段替换为value
            cb(result);
          })
          .catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      } else {
        cb([]);
      }
    },
    handleSelect(item) {
      this.editForm.INNER_CODE = item.INNER_CODE;
    },
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        CAN_USE: this.searchForm.STATUS,
      };
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      queryPackageName(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].OP_ROLE;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    openAdd() {
      this.editFormVisible = true;
    },
    submitAdd() {
      if (this.editForm.NAME) {
        const params = {
          NAME: this.editForm.NAME,
        };
        addPackageFun(params).then((result) => {
          this.$message.show({ text: '新增成功', type: 'success' });
          this.editForm = {};
          this.queryData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请输入产品名称', type: 'warning' });
      }
    },
    matchDishes(row) {
      this.$router.push({ name: 'matchDishes' });
      sessionStorage.setItem('menuCode', row.PRODUCT_CODE);
    },
    matchProduct() {
      if (this.editForm.INNER_CODE) {
        const params = {
          PRODUCT_CODE: this.editForm.INNER_CODE,
        };
        matchPackageFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.editForm = {};
          this.queryData();
          this.editFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    deleteRecord(row) {
      this.$confirm('确认删除该套餐吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ID: row.ID,
        };
        if (row.STATUS == 0) {
          params.STATUS = 1;
        } else {
          params.STATUS = 0;
        }
        changePackageFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/packageSet.vue